var exports = {
  "K": "GuildJoinMessage.module__icon___bEdvQT",
};

module.exports = exports;
